export const PADDOCK_MAP_CONTAINER_ID = "paddock-map-container";

export const DEFAULT_MAP_CENTER: [number, number] = [135.78, -34.17];
export const DEFAULT_MAP_ZOOM = 15;
export const DEFAULT_MAP_STYLE = "mapbox://styles/mapbox/satellite-streets-v12";

export const PADDOCK_SOURCE_ID = "paddocks";
export const PADDOCK_LABELS_SOURCE_ID = "paddock-label-points";
export const PADDOCK_FILL_LAYER_ID = "paddock-fill";
export const PADDOCK_OUTLINE_LAYER_ID = "paddock-outline";
export const PADDOCK_LABELS_LAYER_ID = "paddock-labels";

// ─── GL layer paint colours ──────────────────────────────────────────────────
// GL paint properties cannot reference CSS var(), so we mirror the design
// tokens as JS constants here. These must be kept in sync with the CSS custom
// properties declared in tokens.css.
export const GL_COLOR_SUCCESS = "#00614f"; // --color-success
export const GL_COLOR_WHITE = "#ffffff"; // --color-white
export const GL_COLOR_BLACK = "#000000"; // generic black (text, halos)
export const GL_COLOR_MB_ORANGE = "#fbb03b"; // MapboxDraw default vertex/midpoint colour

// ─── OpterraPhoenix-aligned colour palette ───────────────────────────────────
export const PADDOCK_COLORS = {
  selected: "rgba(255, 255, 255, 0.7)", // white semi-transparent fill when selected
  default: "transparent", // no fill for unselected paddocks
  outline: GL_COLOR_WHITE, // white border (readable on satellite imagery)
} as const;

export const PADDOCK_LAYER_CONFIG = {
  fillOpacity: 0.4,
  outlineWidth: 2,
} as const;

export const MAP_CONTROLS_POSITION = {
  topRight: "top-right" as const,
  topLeft: "top-left" as const,
} as const;

export const DEFAULT_NEW_PADDOCK_NAME = "New Paddock";
export const AREA_CONVERSION_FACTOR = 10_000; // square meters to hectares
